<template>
  <div>
    <div v-if="!isEmpty(reviews)" :class="`${classVariableName}-review-carousel-container`">
      <div :class="`${classVariableName}-review-carousel`">
        <div :style="{minHeight:'240px', margin:'0 16px'}">
          <ReviewVue :isCarousel="true" :isExpanded="isExpanded"
            :mobView="true" :review="reviews[currentIndex]" :validationConfig="validationConfig"
            :product="product"
            :setAlert="(message, type) => setAlert(message, type)"
            :vote="isEmpty(userCurrentReview) || userCurrentReview.id !== reviews[currentIndex].id"
          />
        </div>
        <button :class="`${classVariableName}-prev-button`">
          <div :class="`${classVariableName}-button-icon`" v-if="reviews.length > 1" @click="prevImage">
            <Arrow :direction="'left'" />
          </div>
        </button>
        <button :class="`${classVariableName}-next-button`">
          <div :class="`${classVariableName}-button-icon`" v-if="reviews.length > 1" @click="nextImage">
            <Arrow :direction="'right'" />
          </div>
        </button>
      </div>
    </div>
    <div :class="`${classVariableName}-slick-man`">
      <span
        v-for="(review, index) in reviews" :key="index"
        :class="index === currentIndex ? `${classVariableName}-dot-active` : `${classVariableName}-dot`"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { isEmpty, classVariableName } from "../../utils";
import ReviewVue from "../Review.vue";
import Arrow from "../common/Arrow.vue";

export default defineComponent({
  name: "ReviewCarousel",
  setup() {},
  components: {
    ReviewVue,
    Arrow,
  },
  data() {
    return {
      classVariableName: classVariableName,
      currentIndex: 0,
      isExpanded: false,
    };
  },
  props: {
    product: Object,
    userCurrentReview: Object,
    reviews: {
      type: Array,
      default: [],
    },
    validationConfig: Object,
    setAlert: Function,
  },
  methods: {
    isEmpty(val) {
      return isEmpty(val);
    },
    nextImage() {
      this.isExpanded = false;
      if (this.reviews.length <= 1) return;
      if (this.currentIndex < this.reviews.length - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
    },
    prevImage() {
      this.isExpanded = false;
      if (this.reviews.length <= 1) return;
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import "../../assets/Carousel.scss";
</style>
